import { Pipe, PipeTransform } from '@angular/core'
import { LogoTheme } from '~app/core/logo/ftr/ftr-logo.component'

@Pipe({
  name: 'themedLogoPath',
})
export class ThemedLogoPathPipe implements PipeTransform {
  transform(value: LogoTheme): string {
    const theme = value === LogoTheme.Colored ? 'colored' : 'white'
    return `../../../assets/images/logo-${theme}.svg`
  }
}
